import React, { useState, useEffect, useRef } from "react";
import PopUp from "./PopUp";
import ChoosFoodCart from "./ChoosFoodCart";
import KindFoodNav from "./KindFoodNav";
import {breakfast} from '../assetss/data/food/breakfast';
import {mainFood} from '../assetss/data/food/mainFood';
import {appetizer} from '../assetss/data/food/appetizer';
import {frieds} from '../assetss/data/food/frieds';
import {pizza} from '../assetss/data/food/pizza';
import { italiaPizza } from "../assetss/data/food/italiaPizza";
import {burgerAndSandwich} from '../assetss/data/food/burgerAndSandwich';
import {drinks} from '../assetss/data/food/drinks';
import {coffee} from '../assetss/data/food/coffee';
import {hotDrinkOnCoffee} from '../assetss/data/food/hotDrinkOnCoffee';
import {hotDrink} from '../assetss/data/food/hotDrink';
import {smooti} from '../assetss/data/food/smooti';
import {moktel} from '../assetss/data/food/moktel';
import {teaAndHerbal} from '../assetss/data/food/teaAndHerbal';
import {iceCoffee} from '../assetss/data/food/iceCoffee';
import {cake} from '../assetss/data/food/cake';
import {shake} from '../assetss/data/food/shake';
import {iceCream} from "../assetss/data/food/iceCream";
import {ghelian} from '../assetss/data/food/ghelian'
import {iceTea} from '../assetss/data/food/iceTea'
import {fizzy} from '../assetss/data/food/fizzy'
import { irani } from "../assetss/data/food/irani";
import { cooffee } from "../assetss/data/food/cooffee";
import { other } from "../assetss/data/food/other";
import { vegan } from "../assetss/data/food/vegan";

const ChooseFoodPart = ({ qty, setQty, onAdd, increase, decrease }) => {

  const [active, setActive] = useState(null);
  // const [active, setActive] = useState(false);
  const storedId = localStorage.getItem("visible");

  useEffect(() => {
    console.log(storedId);
  }, [storedId]);
  const [show, setShow] = useState(true)
  useEffect(() => {
    // Check if the popup has been shown before
    const popupShownBefore = sessionStorage.getItem('popupShown');

    if (popupShownBefore) {
      // If the popup has been shown before, do not show it again
      setShow(false);
    } else {
      // localStorage.setItem('popupShown' , 'true');
      // If the popup has not been shown before, show it and set the flag in localStorage
    }
  }, []); // Run this effect only once when the component mounts


  return (
    <div className="relative">
      <KindFoodNav storedId={storedId} active={active} setActive={setActive} />
      <ChoosFoodCart
        setActive={setActive}
        title="صبحانه"
        idName="breakfast"
        kinds={breakfast}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="غذای اصلی"
        idName="mainFood"
        kinds={mainFood}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="پیش غذا"
        idName="appetizer"
        kinds={appetizer}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="سوخاری"
        idName="frieds"
        kinds={frieds}
      />
      {/* <ChoosFoodCart
        setActive={setActive}
        title="پیتزا"
        idName="pizza"
        kinds={pizza}
      /> */}
      <ChoosFoodCart
        setActive={setActive}
        title="پیتزا ناپولی"
        idName="italiaPizza"
        kinds={italiaPizza}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="برگر و ساندویچ"
        idName="burgerAndSandwich"
        kinds={burgerAndSandwich}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="وگان"
        idName="vegan"
        kinds={vegan}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="نوشیدنی"
        idName="drinks"
        kinds={drinks}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="نوشیدنی‌های گازدار"
        idName="fizzy"
        kinds={fizzy}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="قهوه ها"
        idName="coffee"
        kinds={coffee}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="قهوه های دمی"
        idName="cooffee"
        kinds={cooffee}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="نوشیدنی گرم بر پایه قهوه"
        idName="hotDrinkOnCoffee"
        kinds={hotDrinkOnCoffee}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="نوشیدنی های گرم"
        idName="hotDrink"
        kinds={hotDrink}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="اسموتی"
        idName="smooti"
        kinds={smooti}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="ماکتل"
        idName="moktel"
        kinds={moktel}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="چای و دمنوش"
        idName="teaAndHerbal"
        kinds={teaAndHerbal}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="آیس کافی"
        idName="iceCoffee"
        kinds={iceCoffee}
      />
        <ChoosFoodCart
          setActive={setActive}
          title="آیس تی"
          idName="iceTea"
          kinds={iceTea}
        />
      <ChoosFoodCart
        setActive={setActive}
        title="کیک و چیز کیک"
        idName="cake"
        kinds={cake}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="شیک"
        idName="shake"
        kinds={shake}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="بستنی و کیک بستنی"
        idName="iceCream"
        kinds={iceCream}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="قلیان"
        idName="ghelian"
        kinds={ghelian}
      />
      {/* <ChoosFoodCart
        setActive={setActive}
        title="غذای ایرانی"
        idName="irani"
        kinds={irani}
      /> */}
      <ChoosFoodCart
        setActive={setActive}
        title="سایر"
        idName="other"
        kinds={other}
      />

      <PopUp show={show} setShow={setShow} />
    </div>
  );
};

export default ChooseFoodPart;
